<template>
  <div>
    <div @click.stop="showModal">
      <slot name="body">
        <a-button type="primary" ghost>{{title}}</a-button>
      </slot>
    </div>

    <a-modal
      v-model="modalVisible"
      :destroyOnClose="true"
      centered
      :footer="false"
      :width="900"
      :zIndex="9999"
      :title="$t('common.material')"
      @cancel="closeModal"
    >
      <div>
        <!--列表-->
        <material-list ref="materialList" :type="type" @selected="handleSelected" @showUpload="showUpload" @dirChange="onDirChange"/>
        <!--上傳-->
        <div class="upload-box" v-if="uploadVisible">
          <div class="titles"><span @click="onClickBack"><a-icon type="arrow-left" /></span>{{$t('common.material')}}</div>
          <div class="contents">
            <!--上傳提示-->
            <div class="upload-state" v-if="uploadState">
              <a-result v-if="stateSuccess" :title="$t('message.uploadSuccess')" status="success">
                <span style="font-size:18px;" v-if="reviewInfo">{{reviewInfo}}</span>
              </a-result>
              <a-spin v-else :tip="$t('message.uploading2')">
              </a-spin>
            </div>
            <!--上傳的列表-->
            <drag-uploader @updateImagefiles="handleFileChange" :uptype="uptype"></drag-uploader>
          </div>
          <div class="btn-box"><a-button :disabled="fileList.length>0?false:true" type="primary" class="ant-btns" @click="saveData">{{$t('actionTitles.uploadConfirm')}}</a-button></div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import DragUploader from "../DragUploader";
import { infiniteScroll } from "vue-infinite-scroll";
import {
  materialPageQuery,
  getFolderDepth,
  materialAdd,
} from "@/api/planeMaterial";
import MaterialList from "./components/MaterialList";
import { mapGetters } from "vuex";


export default {
  props: {
    title: {
      type: String,
      default() {
        return this.$t('message.uploadBtn');
      },
    },
    type: {
      required: true,
      type: Number,
    },
  },
  components: { DragUploader, MaterialList },
  directives: { infiniteScroll },
  data() {
    return {
      fileList: [],
      imageList: [],
      audioList: [],
      videoList: [],
      folderDepthList: [],
      dataSourse: [],
      loading: false,
      busy: false,
      modalVisible: false,
      uptype: "pic",
      typeDesc: this.$t('moduleTitles.imageList'),
      uploadVisible:false,
      uploadState: false,
      stateSuccess:false,
      reviewInfo: "",
      dir_id: 0
    };
  },
  computed: {
    ...mapGetters([
      "userInfo"
    ]),
  },
  watch: {
    type: {
      handler: function (value) {
        if (value == 1) {
          this.uptype = "pic";
          this.typeDesc = this.$t('moduleTitles.imageList');
        } else if (value == 2) {
          this.uptype = "audio";
          this.typeDesc = this.$t('moduleTitles.audioList');
        } else {
          this.uptype = "video";
          this.typeDesc = this.$t('edit.video');
        }
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {
  },
  methods: {
    onClickBack() {
      this.quitInitData()
    },
    handleFileChange(files) {
      this.fileList = files;
    },
    saveData(){
      if(this.fileList.length === 0) {
        return;
      }
      this.uploadState=true
      let list = []
      this.fileList.forEach(item => {
        list.push({
          name: item.name,
          type: this.type,
          url: item.url,
          filesize: item.filesize,
          dir_id:this.dir_id
        })
      })

      materialAdd(list).then((res) => {
        this.$refs.materialList.resetLoad();
        this.stateSuccess=true
        let time = 1000;
        if(res.data && res.data.type === 1) {
          this.reviewInfo=res.data.message
          time = 2500
        }
        setTimeout(()=>{
          this.quitInitData()
        },time)
      });
    },
    quitInitData() {
      this.uploadVisible=false
      this.stateSuccess=false
      this.uploadState=false
      this.fileList=[]
      this.reviewInfo=""
    },
    handleSelected(item) {
      this.$emit("selected", item);
      this.modalVisible = false;
    },
    showModal() {
      this.modalVisible = true;
    },
    showUpload(){
      this.uploadVisible = true
      console.log('this.fileList',this.fileList)
    },
    closeModal(){
      setTimeout(()=>{this.uploadVisible=false},1000)
    },
    onDirChange(id){
      this.dir_id = id;
    }
  },
};
</script>

<style lang="less" scoped>
.dir-wrapper {
  display: flex;
  align-items: center;
  .dir-title {
    margin-left: 10px;
  }
}

.demo-infinite-container {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: auto;
  padding: 8px 24px;
  height: 300px;
}
.demo-loading-container {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
  .upload-box{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 11;
    background: #ffffff;
    border-radius: 4px;
    padding: 20px;
    .titles{
      width: 100%;
      font-size: 16px;
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #e8e8e8;
      span{
        display: flex;
        width: 34px;
        height: 34px;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
    .contents{
      height: calc(100% - 120px);
      margin-top: 20px;
      overflow: hidden;
      overflow-y: auto;
      .upload-state{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(255,255,255,.8);
        z-index: 10;
      }
    }
    .btn-box{
      padding-top: 15px;
      text-align: right;
      .ant-btns{
        height: 38px;
        line-height: 38px;
      }
      .confirmBtn {
        background-color: #7101ad;
        border-color:#7101ad;
      }
    }
  }
</style>
